function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { Button } from "./Button";
import { FlippableCard } from "./CardStack";
import { Icon } from "./Icon";
import { Text } from "./Text";
import { View } from "./View";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../styles";
/**
 * Displayed at the end of a
 * <https://ouihealth.atlassian.net/browse/APPCORE-29> to inform the user
 * they've reached the end of the cards in the current stack.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-101}
 */ export function ReviewCompleteCard(_param) {
    var doneText = _param.doneText, onActive = _param.onActive, onDone = _param.onDone, onReset = _param.onReset, resetText = _param.resetText, text = _param.text, rest = _object_without_properties(_param, [
        "doneText",
        "onActive",
        "onDone",
        "onReset",
        "resetText",
        "text"
    ]);
    var internalProps = rest;
    var theme = useTheme().theme;
    var onActiveRef = useRef(onActive);
    onActiveRef.current = onActive;
    var $t = useI18n().$t;
    var isActive = internalProps.index === internalProps.animatedIndex.value;
    useEffect(function() {
        if (isActive) {
            var _onActiveRef_current;
            (_onActiveRef_current = onActiveRef.current) === null || _onActiveRef_current === void 0 ? void 0 : _onActiveRef_current.call(onActiveRef);
        }
    }, [
        isActive
    ]);
    return /*#__PURE__*/ _jsx(FlippableCard, _object_spread_props(_object_spread({}, internalProps), {
        // Needs to be a FlippableCard for proper stacking,
        // but we disable flipping by setting backChildren to null
        backChildren: null,
        frontChildren: /*#__PURE__*/ _jsxs(View, {
            style: {
                paddingHorizontal: 20
            },
            testID: "ReviewCompleteCard",
            children: [
                /*#__PURE__*/ _jsx(View, {
                    style: {
                        backgroundColor: '#ebf1ed',
                        borderRadius: 35,
                        height: 50,
                        width: 50,
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center'
                    },
                    "aria-hidden": true,
                    children: /*#__PURE__*/ _jsx(Icon, {
                        name: "check",
                        color: theme.color.success,
                        "aria-label": undefined,
                        size: 24
                    })
                }),
                /*#__PURE__*/ _jsx(Text, {
                    text: text !== null && text !== void 0 ? text : $t({
                        id: 'ReviewCompleteCard_complete',
                        defaultMessage: 'Review complete'
                    }),
                    size: 21,
                    weight: "semibold",
                    style: {
                        marginTop: 12,
                        marginBottom: 40
                    },
                    textAlign: "center"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    _useGestureHandler: true,
                    onPress: onDone,
                    text: doneText !== null && doneText !== void 0 ? doneText : $t({
                        id: 'ReviewCompleteCard_doneButton',
                        defaultMessage: 'Done'
                    }),
                    variant: "solid",
                    style: {
                        marginBottom: 20
                    },
                    alignSelf: "stretch",
                    testID: "ReviewCompleteCard_doneButton"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    _useGestureHandler: true,
                    onPress: onReset,
                    text: resetText !== null && resetText !== void 0 ? resetText : $t({
                        id: 'ReviewCompleteCard_resetButton',
                        defaultMessage: 'Reset cards'
                    }),
                    alignSelf: "stretch",
                    testID: "ReviewCompleteCard_resetButton"
                })
            ]
        })
    }));
}
